import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ApplicationWrapper } from './components/ApplicationWrapper';
// import './assets/styles.css';

ReactDOM.render(
  <ApplicationWrapper />,
  document.getElementById('root')
);